// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"e689d859","703":"6d4fdf06","787":"ebbc7e70","820":"96396b68"}[chunkId] + ".chunk.js";
};